import { render } from "./ProjectList.vue?vue&type=template&id=5714bc02&scoped=true"
import script from "./ProjectList.vue?vue&type=script&lang=js"
export * from "./ProjectList.vue?vue&type=script&lang=js"

import "./ProjectList.vue?vue&type=style&index=0&id=5714bc02&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5714bc02"

export default script